<template>
  <div class="flex-auto">
    <div class="relative px-4 sm:px-6 lg:px-8 pt-16 pb-20">
      <div id="content_area" class="relative max-w-7xl mx-auto mt-5 flex-auto">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasicWrapper",
  props: {
    class: String,
    white: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
